import { styled } from "@sourceful/shared-components";
import toRem from "@styles/postprocess/conversion/to-rem";

export const ProductDetailContent = styled("section", {
  margin: "0 auto",
  maxWidth: "1200px",
  height: "100%",
  width: "100%",
  display: "grid",
  gridGap: toRem(20),
  gridTemplateColumns: "1fr",
  gridAutoRows: "max-content",
  paddingBottom: toRem(60),
  "@lg": {
    gridTemplateColumns: `1fr ${toRem(450)}`,
  },
  "@sm": {
    paddingTop: toRem(38),
  },
});
